// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--33bb1";
export var iconSection = "footer-module--icon-section--958ad";
export var svgLeetCode = "footer-module--svg-leet-code--a5f62";